import {EventTypes, HandleEventCallback} from '../../types';

type Subscription<
  TData extends Record<TIdKey, any>,
  TIdKey extends keyof TData = keyof TData
> = {
  events: EventTypes[];
  callback: HandleEventCallback<TData, TIdKey>;
};

const MockPusherSubscriptions: {
  [channelName: string]: Subscription<any, any>;
} = {};

export const getMockSubscriptionsSingleton = () => MockPusherSubscriptions;
